export enum LocalStorageKey {
  TOKEN = 'EHR_ACCESS_TOKEN',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  LOGIN_ACTIVE_TAB = 'LOGIN_ACTIVE_TAB',
  ASSISTANT_LAST_CONV = 'EHR_ASSISTANT_LAST_CONV',
  ASSISTANT_FAB_POS = 'EHR_ASSISTANT_FAB_POS',
  ASSISTANT_CHAT_SIZE = 'EHR_ASSISTANT_CHAT_SIZE',
  TRACKING_POINT_SCAN = 'EHR_TRACKING_POINT_SCAN',
}
